import { Box } from "ui/box/box";
import {
  OPTION_ALERT_ICON_SX,
  OPTION_CONTENT_SX,
  OPTION_ICON_SX,
  OPTION_MAIN_SX,
  OPTION_NODE_LABEL_SX,
  OPTION_TEXT_LABEL_SX,
} from "ui/select/select.styles";

import Icons from "assets";

import type { OptionType } from "ui/select/select.types";

/**
 * An option's row in the list: its icon, its label and, with `isAlertShown`, the alert glyph at the end.
 * The glyph keeps `error.main` on a selected row too — the selected wash is a light grey, which the old
 * white glyph all but vanished on. A text label wraps; a node label is clipped, since it may not be text.
 */
export const SelectOptionContent = ({ option }: { option: OptionType }) => {
  const { icon, isAlertShown, label } = option;
  const hasStringLabel = typeof label === "string" || label == null;

  return (
    <Box sx={OPTION_CONTENT_SX}>
      <Box sx={OPTION_MAIN_SX}>
        {icon && (
          <Box component="span" sx={OPTION_ICON_SX}>
            {icon}
          </Box>
        )}
        {hasStringLabel ? (
          label != null && (
            <Box component="span" sx={OPTION_TEXT_LABEL_SX}>
              {label}
            </Box>
          )
        ) : (
          <Box component="span" sx={OPTION_NODE_LABEL_SX}>
            {label}
          </Box>
        )}
      </Box>
      {isAlertShown && <Box component={Icons.ExclamationCircle} sx={OPTION_ALERT_ICON_SX} />}
    </Box>
  );
};
